import { concatPagination } from '@apollo/client/utilities';
const typePolicies = {
    Appellation: {
        keyFields: ['id']
    },
    Article: {
        keyFields: ['id'],
        // always replace existing with incoming
        merge: false,
        fields: {
            body: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    ArticleBlock: {
        keyFields: ['id'],
        // always replace existing with incoming
        merge: false
    },
    Bookable: {
        keyFields: ['id'],
        fields: {
            availabilityDates: {
                // always replace existing with incoming
                merge: false
            },
            availabilityTimes: {
                // always replace existing with incoming
                merge: false
            },
            informations: {
                // merge incoming into existing
                merge: true
            },
            rating: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    BookablePrice: {
        keyFields: ['id']
    },
    Cart: {
        keyFields: ['id'],
        fields: {
            crossSell: {
                // always replace existing with incoming
                merge: false
            },
            editorial: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    CartEditorial: {
        // always replace existing with incoming
        merge: false
    },
    Country: {
        keyFields: ['id'],
        fields: {
            seo: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    Dish: {
        keyFields: ['id']
    },
    Distinction: {
        keyFields: ['id']
    },
    Drink: {
        keyFields: ['id']
    },
    DrinkGrape: {
        keyFields: ['id']
    },
    DrinkType: {
        keyFields: ['id']
    },
    Establishment: {
        keyFields: ['id'],
        fields: {
            nearBy: {
                // always replace existing with incoming
                merge: false
            },
            rating: {
                // always replace existing with incoming
                merge: false
            },
            status: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    Event: {
        keyFields: ['id']
    },
    Extra: {
        keyFields: ['id']
    },
    Lang: {
        keyFields: ['id']
    },
    Location: {
        keyFields: ['id'],
        fields: {
            seo: {
                // always replace existing with incoming
                merge: false
            }
        }
    },
    MealEntryItem: {
        keyFields: ['id']
    },
    MediaEntity: {
        merge: true
    },
    Media: {
        keyFields: ['id'],
        fields: {
            file: {
                merge: true
            }
        }
    },
    Menu: {
        keyFields: ['id']
    },
    MenuDrinkInterface: {
        keyFields: ['id']
    },
    MenuItem: {
        keyFields: ['id']
    },
    Order: {
        keyFields: ['id'],
        fields: {
            crossSell: {
                // always replace existing with incoming
                merge: true
            }
        }
    },
    PromoCode: {
        keyFields: ['id']
    },
    Query: {
        fields: {
            allArticles: concatPagination()
        }
    },
    Reservation: {
        keyFields: ['id']
    },
    Tag: {
        keyFields: ['id']
    },
    TypeActivity: {
        keyFields: ['id']
    },
    TypeCulture: {
        keyFields: ['id']
    }
};
export default typePolicies;
